export function initializeTableState (id) {
  return (dispatch) => {
    dispatch({
      type: 'CREATE_MUITABLE',
      id: id
    })
  }
}

export function cleanTableState (id) {
  return (dispatch) => {
    dispatch({
      type: 'DELETE_MUITABLE',
      id: id
    })
  }
}

export const updateMuiTable = (id, newState) => async (dispatch) => {
  if (typeof newState === 'function') {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: { loading: true },
      id
    })
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: await newState(),
      id
    })
  } else {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState,
      id
    })
  }
}
